import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {TrainingListPayload, TrainingListResponse} from './training.models';

import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {NGXLogger} from 'ngx-logger';
import {environment} from '../../../../../../../../environments';

@Injectable()
export class TrainingDataService {

  constructor(private http: HttpClient, private logger: NGXLogger) {
  }

  load(): Observable<TrainingListPayload> {
    return this.http.get<TrainingListResponse>(`${environment.api}/trainings`).pipe(
      map(res => ({items: res.datalist, rows: res.rows})),
    );
  }
}
